export enum RelayConnectionTypes {
  None,
  PhoneIP,
  PhoneNum,
}
